import React, { useCallback, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { ChevronLeftIcon, ChevronRightIcon } from './Icons';

export const ProductImageSlider = ({ images, alt, index }) => {
  const swiperRef = useRef(null);
  const hasMultiple = images.length > 1;
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(!hasMultiple);

  const handlePrev = useCallback(() => swiperRef.current?.slidePrev(), []);
  const handleNext = useCallback(() => swiperRef.current?.slideNext(), []);

  const syncEdges = useCallback((swiper) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  }, []);

  return (
    <div className="relative bg-black">
      <span
        className="absolute right-6 top-0 z-10 flex h-[42px] w-[42px] items-center justify-center rounded-b-[5px] bg-[#0036FC] text-[21px] font-medium uppercase leading-none tracking-[1px] text-white transition-colors duration-300 group-hover:bg-[#1F6FEB]"
        style={{ boxShadow: '0px 3px 6px 0px #323C4C40', fontFamily: 'var(--gp-font--matter)' }}
        aria-label={`Pin ${index}`}
      >
        {index}
      </span>

      <div className="overflow-hidden">
      <Swiper
        slidesPerView={1}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
          syncEdges(swiper);
        }}
        onSlideChange={syncEdges}
      >
        {images.map((src, i) => (
          <SwiperSlide key={src + i} className="overflow-hidden">
            <img
              src={src}
              alt={`${alt} ${i + 1}`}
              loading="lazy"
              className="block h-[14rem] w-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.05] lg:h-[15rem]"
            />
          </SwiperSlide>
        ))}
      </Swiper>
      </div>

      {hasMultiple && (
        <div className="absolute bottom-[-20px] right-3 z-20 flex">
          <button
            type="button"
            onClick={handlePrev}
            disabled={isBeginning}
            aria-label="Previous image"
            className="flex !h-[36px] !w-[42px] items-center justify-center !rounded-none !rounded-bl-[5px] !rounded-tl-[5px] !border-0 !bg-[#000000] !p-0 text-white !opacity-100 !shadow-none transition-colors duration-300 hover:!bg-[#1F6FEB] focus:!outline-none"
          >
            <ChevronLeftIcon height={32} width={32} />
          </button>
          <button
            type="button"
            onClick={handleNext}
            disabled={isEnd}
            aria-label="Next image"
            className="flex !h-[36px] !w-[42px] items-center justify-center !rounded-none !rounded-br-[5px] !rounded-tr-[5px] !border-0 !bg-[#000000] !p-0 text-white !opacity-100 !shadow-none transition-colors duration-300 hover:!bg-[#1F6FEB] focus:!outline-none"
          >
            <ChevronRightIcon height={32} width={32} />
          </button>
        </div>
      )}
    </div>
  );
};
